import { Stack, styled, Typography } from '@mui/material';

export const StyledContainer = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  [theme.breakpoints.up('desktop')]: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0, 3),
  },
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  fontSize: 32,
  lineHeight: theme.spacing(6),
  fontWeight: 500,
  textTransform: 'uppercase',
}));
StyledTitle.defaultProps = {
  variant: 'h1',
  align: 'center',
};

export const StyledSubtitle = styled(Typography)({});
StyledSubtitle.defaultProps = {
  align: 'center',
};
